<template>
  <el-card>
    <section>
      <!--工具条-->
      <el-col :span="24" class="form-line">
        <el-form size="small" :inline="true" :model="filters">
<!--          <el-form-item label="登录名">-->
<!--            <el-input v-model="filters.username" auto-complete="off"></el-input>-->
<!--          </el-form-item>-->
          <el-form-item label="手机号（登录名）">
            <el-input v-model="filters.phone" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="真实姓名">
            <el-input v-model="filters.name" auto-complete="off"></el-input>
          </el-form-item>
          <el-form-item label="车牌号">
            <el-input v-model="filters.carNo" auto-complete="off"></el-input>
          </el-form-item>
          <div style="float: right">
            <el-form-item>
              <el-button-group>
                <el-button type="primary" icon="el-icon-search" @click="getDriverList()">查询</el-button>
                <el-button icon="el-icon-refresh-right" @click="resetFilter()">重置</el-button>
              </el-button-group>
            </el-form-item>
            <el-button size="small" icon="el-icon-plus" type="primary" style="max-resolution: 20px;" @click="handleAdd()">新增</el-button>
          </div>
        </el-form>
      </el-col>

      <!--列表-->
      <el-table border size="medium" :data="driverList" highlight-current-row v-loading="listLoading" @selection-change="selsChange">
        <el-table-column type="index" min-width="60">
        </el-table-column>
<!--        <el-table-column prop="username" label="登录名" min-width="120">-->
<!--        </el-table-column>-->
        <el-table-column prop="phone" label="手机号（登录名）" min-width="120">
        </el-table-column>
        <el-table-column prop="name" label="真实姓名" min-width="120">
        </el-table-column>
        <el-table-column prop="carNo" label="车牌号" min-width="120">
        </el-table-column>
        <el-table-column prop="points" label="积分" min-width="120">
        </el-table-column>

<!--        <el-table-column prop="status" label="状态" min-width="120" :formatter="statusFormatter">-->
<!--        </el-table-column>-->
        <el-table-column label="操作" min-width="120">
          <template slot-scope="scope">
            <el-button class="btn-text-pd0" size="mini" type="text" @click="handleEdit(scope.row.id)">编辑</el-button>
            <el-button class="btn-text-pd0" size="mini" type="text" @click="resetPwd(scope.row.id)">重置密码</el-button>
            <el-button class="btn-text-pd0" size="mini" type="text" @click="toAddPoints(scope.row.id)">充值积分</el-button>
            <el-button class="btn-text-pd0" size="mini" type="text" @click="toGetPointsHistory(scope.row.id)">积分明细</el-button>
            <el-button class="btn-text-pd0" size="mini" type="text" @click="handleDel(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!--工具条-->
      <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          style="padding: 15px 5px">
      </el-pagination>

      <!--新增界面-->
      <el-dialog title="新增" :visible.sync="addFormVisible" :close-on-click-modal="false">
        <el-form size="small" :model="addForm" label-width="150px" :rules="addFormRules" ref="addForm">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="手机号（登录名）" prop="phone">
                <el-input :readonly="editFlag" v-model="addForm.phone" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号" prop="idCard">
                <el-input v-model="addForm.idCard" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="真实姓名" prop="name">
                <el-input v-model="addForm.name" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别" prop="sex">
                <el-select style="width: 100%" clearable v-model="addForm.sex" placeholder="请选择">
                  <el-option
                      v-for="item in sexList"
                      :key="item.label"
                      :label="item.label"
                      :value="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="车牌号" prop="carNo">
                <el-input v-model="addForm.carNo" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="驾驶证号">
                <el-input v-model="addForm.drivingLicense" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="驾驶证开始日期" >
                <el-date-picker type="date"
                                placeholder="请选择开始日期"
                                value-format="yyyy-MM-dd"
                                v-model="addForm.drivingLicenseStartDate"
                                style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="驾驶证截止日期" >
                <el-date-picker type="date"
                                placeholder="请选择开始日期"
                                value-format="yyyy-MM-dd"
                                v-model="addForm.drivingLicenseEndDate"
                                style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="从业资格证号" >
                <el-input v-model="addForm.qualificationLicense" auto-complete="off"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="资格证类型" >
                <el-select style="width: 100%" clearable v-model="addForm.qualificationLicenseType" placeholder="请选择">
                  <el-option
                      v-for="item in zgzList"
                      :key="item.label"
                      :label="item.label"
                      :value="item.label">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="资格证开始日期">
                <el-date-picker type="date"
                                placeholder="请选择开始日期"
                                value-format="yyyy-MM-dd"
                                v-model="addForm.firstIssueDate"
                                style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="资格证截止日期" >
                <el-date-picker type="date"
                                placeholder="请选择开始日期"
                                value-format="yyyy-MM-dd"
                                v-model="addForm.qualificationLicenseEndDate"
                                style="width: 100%;">
                </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="驾驶证图片">
                <el-image class="object-contain" v-if="addForm.drivingLicenseImage!='' && addForm.drivingLicenseImage != null" :key="addForm.drivingLicenseImage" :src="addForm.drivingLicenseImage" alt="" :preview-src-list="addForm.drivingLicenseImage.split(' ')"></el-image>
                <img class="object-contain" v-if="addForm.drivingLicenseImage=='' || addForm.drivingLicenseImage == null" src="../../assets/img_defult.png" alt="">
                <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :on-change="handleChanges1"
                    :file-list="fileList"
                    list-type="picture" name="multipartFile" :multiple="true"
                    :before-upload="beforeAvatarUpload" :limit="1">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip"></div>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="资格证图片">
                <el-image class="object-contain" v-if="addForm.qualificationLicenseImage!='' && addForm.qualificationLicenseImage != null" :key="addForm.qualificationLicenseImage" :src="addForm.qualificationLicenseImage" alt="" :preview-src-list="addForm.qualificationLicenseImage.split(' ')"></el-image>
                <img class="object-contain" v-if="addForm.qualificationLicenseImage=='' || addForm.qualificationLicenseImage == null" src="../../assets/img_defult.png" alt="">
                <el-upload
                    class="upload-demo"
                    :action="uploadUrl"
                    :on-change="handleChanges2"
                    :file-list="fileList"
                    list-type="picture" name="multipartFile" :multiple="true"
                    :before-upload="beforeAvatarUpload" :limit="1">
                  <el-button size="small" type="primary">点击上传</el-button>
                  <div slot="tip" class="el-upload__tip"></div>
                </el-upload>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="addFormVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click.native="addSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <el-dialog width="30%" title="充值积分" :visible.sync="addPointsVisible" :close-on-click-modal="false">
        <el-form size="small" :model="addPoints" label-width="150px" :rules="addPointsRules" ref="addPoints">
          <el-form-item label="充值数量" prop="changePoints">
            <el-input-number style="width: 100%" v-model="addPoints.changePoints" auto-complete="off"></el-input-number>
          </el-form-item>
          <el-form-item label="备注" >
            <el-input type="textarea" v-model="addPoints.description"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="addPointsVisible = false">取消</el-button>
          <el-button size="small" type="primary" @click.native="addPointsSubmit" :loading="addLoading">提交</el-button>
        </div>
      </el-dialog>

      <el-dialog width="70%" title="积分明细" :visible.sync="pointsListVisible" :close-on-click-modal="false">
        <!--列表-->
        <el-table border size="medium" :data="pointsList" highlight-current-row v-loading="listLoading">
          <el-table-column type="index" min-width="60">
          </el-table-column>
          <el-table-column prop="changeType" label="类型" :formatter="formatterChangeType" min-width="10">
          </el-table-column>
          <el-table-column prop="currPoints" label="修改前积分" min-width="8">
          </el-table-column>
          <el-table-column prop="changePoints" label="修改积分" min-width="8">
          </el-table-column>
          <el-table-column prop="finalPoints" label="修改后积分" min-width="8">
          </el-table-column>
          <el-table-column prop="remark" label="修改说明" min-width="30">
          </el-table-column>
          <el-table-column prop="description" label="备注" min-width="15">
          </el-table-column>
          <el-table-column prop="createDate" label="时间" min-width="15">
          </el-table-column>
        </el-table>

        <!--工具条-->
        <el-pagination
            @size-change="handleSizeChange2"
            @current-change="handleCurrentChange2"
            :page-sizes="[10, 20, 30, 40]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="pointsTotal"
            style="padding: 15px 5px">
        </el-pagination>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click.native="pointsListVisible = false">关闭</el-button>
        </div>
      </el-dialog>
    </section>
  </el-card>
</template>

<script>
/* eslint-disable */
import {base, doPost, download} from "@/api/api";

export default {
  name: 'DriverManagement',
  data () {
    return {
      uploadUrl: base + '/uploadFile/upload',
      fileList: [],
      filters: {
        username: '',
        name: '',
        carNo: '',
        phone: ''
      },
      driverList: [],
      total: 0,
      listLoading: false,
      sels: [], // 列表选中列
      addFormVisible: false, // 新增界面是否显示
      addLoading: false,
      addFormRules: {
        name: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' }
        ],
        carNo: [
          { required: true, message: '请输入车牌号', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '手机号格式错误', trigger: 'blur' }
        ],
      },
      // 新增界面数据
      addForm: {
        username: '',
        name: '',
        sex: '',
        phone: '',
        carNo: '',
        drivingLicense: '',
        drivingLicenseImage: '',
        qualificationLicenseImage: ''
      },
      editFlag: false,
      messageTitle: '',
      messageSuc: '',
      value: '',
      user: {},
      sexList: [{label: '男',value: '男'},{label: '女',value: '女'}],
      zgzList: [{label: '出租汽车驾驶员从业资格',value: '出租汽车驾驶员从业资格'}],
      addPoints: {
        driverId: '',
        changePoints: 0,
        description: ''
      },
      addPointsRules: {
        changePoints: [
          { required: true, message: '请输入充值数量', trigger: 'blur' },
          {
            validator: (rule, value, callback) => {
              if (!Number.isInteger(value)) {
                callback(new Error('必须为整数'));
              } else {
                callback();
              }
            },
            trigger: 'change'
          }
        ]
      },
      addPointsVisible: false,
      pointsListVisible: false,
      pointsList: [],
      pointsFilters: {
        driverId: ''
      },
      pointsTotal: 0
    }
  },
  methods: {
    formatterChangeType(row){
      if(row.changeType === 'H'){
        return '积分充值'
      }
      if(row.changeType === 'S'){
        return '订单消耗'
      }
      return ''
    },
    toGetPointsHistory(driverId){
      this.pointsFilters.driverId = driverId
      this.pointsListVisible = true
      this.doGetPointsHistory()
    },
    doGetPointsHistory(){
      doPost('/driverPoints/getPageList', this.pointsFilters).then((res) => {
        console.log(res.result)
        this.pointsTotal = res.result.total
        this.pointsList = res.result.list
      })
    },
    handleChanges1 (file, fileList) {
      console.log(111)
      if (fileList[0].status === 'success') {
        this.addForm.drivingLicenseImage = fileList[0].response.result
        console.log(this.addForm.drivingLicenseImage)
      }
    },
    handleChanges2 (file, fileList) {
      if (fileList[0].status === 'success') {
        this.addForm.qualificationLicenseImage = fileList[0].response.result
      }
    },
    // 限制上传格式
    beforeAvatarUpload (file) {
      const isJPG = file.type === 'image/jpeg'
      const isLt10M = file.size / 1024 / 1024 < 10
      const isPNG = file.type === 'image/png'
      if (!isJPG && !isPNG) {
        this.$message.error('上传图片能是JPG格式或PNG格式!')
      }
      if (!isLt10M) {
        this.$message.error('上传图片大小不能超过 10MB!')
      }
      return (isJPG || isPNG) && isLt10M
    },
    handleSizeChange (val) {
      this.filters.pageSize = val
      this.getDriverList()
    },
    handleCurrentChange (val) {
      this.filters.pageNum = val
      this.getDriverList()
    },
    handleSizeChange2 (val) {
      this.pointsFilters.pageSize = val
      this.doGetPointsHistory()
    },
    handleCurrentChange2 (val) {
      this.pointsFilters.pageNum = val
      this.doGetPointsHistory()
    },
    resetFilter () {
      Object.assign(this.$data.filters, this.$options.data().filters)
    },
    // 获取消息列表
    getDriverList () {
      this.loading = true
      doPost('/driver/getPageList', this.filters).then((res) => {
        console.log(res.result)
        this.total = res.result.total
        this.driverList = res.result.list
        this.loading = false
      })
    },
    downloadUser () {
      // axios下载数据
      download('/user/downloadUser', this.filters, '用户数据.xls')
    },
    resetPwd: function (id){
      this.$confirm('是否确认重置密码?', '提示', {
        type: 'warning'
      }).then(() => {
        this.loading = true
        var para = { id: id }
        doPost('/driver/resetPwd', para).then((res) => {
          this.loading = false
          this.$message({
            message: '重置成功',
            type: 'success'
          })
          this.getDriverList()
        })
      }).catch(() => {

      })
    },
    // 删除
    handleDel: function (id) {
      this.$confirm('是否确认删除?', '提示', {
        type: 'warning'
      }).then(() => {
        this.loading = true
        var para = { id: id }
        doPost('/driver/deleteById', para).then((res) => {
          this.loading = false
          this.$message({
            message: '删除成功',
            type: 'success'
          })
          this.getDriverList()
        })
      }).catch(() => {

      })
    },
    handleEdit: function (id){
      this.messageTitle = '修改'
      this.messageSuc = '修改成功'
      var para = {id: id}
      doPost('/driver/getById', para).then((res) => {
        this.addForm = res.result
        this.editFlag = true
        this.addFormVisible = true
      })
    },
    // 显示新增界面
    handleAdd: function () {
      this.editFlag = false
      this.addFormVisible = true
      // form字段重置
      Object.assign(this.$data.addForm, this.$options.data().addForm)
      this.messageTitle = '新增'
      this.messageSuc = '新增成功'
    },
    addSubmit: function () {
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.addLoading = true
            doPost('/driver/saveOrUpdate', this.addForm).then(res => {
              console.log(res)
              this.addLoading = false
              if (res.code === 200) {
                this.addFormVisible = false
                // 修改成功  提示信息
                this.$message({
                  message: this.messageSuc,
                  type: 'success'
                })
                this.getDriverList()
              }else{
                this.$message({
                  message: res.result,
                  type: 'error'
                })
              }
            })
          })
        }
      })
    },
    toAddPoints(driverId){
      this.addPoints = {
        driverId: driverId,
        changePoints: 0,
        description: ''
      }
      this.addPointsVisible = true
    },
    addPointsSubmit: function () {
      this.$refs.addPoints.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交吗？', '提示', {}).then(() => {
            this.addLoading = true
            doPost('/driverPoints/addDriverPoints', this.addPoints).then(res => {
              console.log(res)
              this.addLoading = false
              this.addPointsVisible = false
              // 修改成功  提示信息
              this.$message({
                message: '充值成功',
                type: 'success'
              })
              this.getDriverList()
            })
          })
        }
      })
    },
    selsChange: function (sels) {
      this.sels = sels
    },
    // 批量删除
    batchRemove: function () {
    },
    statusFormatter (row, column) {
      if (row.status === 1) {
        return '未读'
      } else if (row.status === 2) {
        return '已读'
      }
    }
  },
  mounted () {
    this.user = JSON.parse(sessionStorage.getItem('user'))
    this.getDriverList()
  }
}
</script>

<style scoped>
.driver-management {
  padding: 20px;
}

.object-contain {
  height: 160px;
  width: 100%;
  object-fit: contain;
  display: block;
  text-align: center;
}
.object-contain /deep/ .el-image__inner {
  object-fit: contain;
}
.object-contain /deep/ .el-image-viewer__close {
  color: #fff;
}
</style>
